import { SkeletonBox } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import { FC, ReactNode } from 'react'

const Container = styled(SkeletonBox)`
  position: relative;
`

const VerticalBackground = styled(Box)`
  position: absolute;
  left: 13px;
  right: 13px;
  height: 100%;
  background: #c4c4c422;
  border-radius: 2px;
`

const VerticalInnerBackground = styled(VerticalBackground)`
  top: 1px;
  left: 14px;
  right: 14px;
  height: calc(100% - 2px);
  background: #333636;
`

const HorizontalBackground = styled(Box)`
  position: absolute;
  top: 9px;
  bottom: 9px;
  width: 100%;
  background: #c4c4c422;
  border-radius: 2px;
`

const HorizontalInnerBackground = styled(HorizontalBackground)`
  left: 1px;
  top: 10px;
  bottom: 10px;
  width: calc(100% - 2px);
  background: #333636;
`

const Content = styled(Box)`
  position: relative;
`

const ApeironCrossBackground: FC<Props> = (props: Props) => {
  const { children, className, loading } = props

  return (
    <Container className={className} loading={loading}>
      <VerticalBackground className='Custom-Vertical-Background' />
      <HorizontalBackground className='Custom-Horizontal-Background' />
      <VerticalInnerBackground className='Custom-Vertical-Inner-Background' />
      <HorizontalInnerBackground className='Custom-Horizontal-Inner-Background' />
      <Content className='Custom-Content'>{children}</Content>
    </Container>
  )
}

type Props = {
  children?: ReactNode
  className?: string
  loading?: boolean
}

export default ApeironCrossBackground
